import { openPinModal } from './pin-modal.js';

/**
 * Diagnostic mode tetikleyici — logo'ya 3x hızlı tık veya F2.
 *
 * Renderer header component logo'ya [data-fp-logo] attribute ekler.
 *
 * Memory: decision_pwa_resilience.md §11
 */
const CLICK_WINDOW_MS = 1500;
const REQUIRED_CLICKS = 3;

let clickCount = 0;
let firstClickAt = 0;

function countTick(): void {
    const now = Date.now();
    if (now - firstClickAt > CLICK_WINDOW_MS) {
        firstClickAt = now;
        clickCount = 1;
        return;
    }
    clickCount++;
    if (clickCount >= REQUIRED_CLICKS) {
        clickCount = 0;
        firstClickAt = 0;
        openPinModal();
    }
}

function onPointer(e: Event): void {
    const target = e.target as Element | null;
    if (target?.closest('[data-fp-logo]')) {
        countTick();
    }
}

function onKey(e: KeyboardEvent): void {
    if (e.key === 'F2') {
        e.preventDefault();
        openPinModal();
    }
}

export function installDiagnosticTrigger(): void {
    document.addEventListener('click', onPointer);
    document.addEventListener('touchend', onPointer, { passive: true });
    window.addEventListener('keydown', onKey);
    console.info('[diagnostic] tetikleyici kuruldu (3x logo / F2)');
}
